import React from 'react'
import { connect } from 'react-redux'
import { Container, Wrapper, Footer, Header } from '../../components_renew/Layout'
import { ConfirmButton } from '../../components_renew/Mall/Buttons'
import { AgreementDeliveryItem } from '../../components_renew/Mall/ShoppingCartItem'
import {
  setOrderConfirmData,
} from '../../actions/mallAction'
import api from '../../api'
import { handleCatch, mapObjectKey, postMessage } from '../../utils'

@connect()
class AgreementDelivery extends React.PureComponent {

  state = {
    data: [],
  }

  // 延时请求
  timeout
  // delayDispatch = (func, delay = 1000) => {
  //   if (this.timeout) {clearTimeout(this.timeout)}
  //   this.timeout = setTimeout(() => {this.props.dispatch(func)}, delay)
  // }

  componentDidMount () {
    if (!window.axios.getToken()) {
      window.toast.info('请先进行登陆', 1, () => {
        // window.postMessage(JSON.stringify({ type: 'loginRequest' }), '*')
        postMessage({ type: window.POST_TYPE.LOGIN_REQUEST })
      })
    } else {
      // this.props.dispatch(requestCartData())
      api.agreement.fetchAgreementDeliveryProductList()
        .then(res => {
          if (res) {
            const data = res.map((item, index) => {
              Object.assign(item, { state: 0 })
              return mapObjectKey(item, {
                name: 'productName'
              })
            })
            this.setState({
              data,
            })
          }
        })
        .catch(handleCatch.bind(this))
    }
  }

  // componentDidUpdate (prevProps, prevState, snapshot) {
  //   if (this.props.data !== prevProps.data) {
  //     this.setState({
  //       data: this.props.data,
  //       dataSource: dataSource.cloneWithRows(this.props.data)
  //     })
  //   }
  // }

  render () {
    let {
      // dataSource,
      data
    } = this.state
    let { loading } = this.props
    // let amount = 0
    // let total = 0
    // data.forEach(item => {
    //   let { state, productCount, currentPrice } = item
    //   if (state === 1) {
    //     amount += productCount
    //     total += (productCount * currentPrice)
    //   }
    // })
    // let renderRow = (rowData) => {
    //   let { id, productId, productName, productCount, currentPrice, state, productPic } = rowData
    //   return <AgreementDeliveryItem
    //     id={id}
    //     index={productId}
    //     title={productName}
    //     productId={productId}
    //     price={currentPrice}
    //     checked={state === 1}
    //     amount={productCount}
    //     imgSrc={productPic}
    //     onItemChecked={this.onItemChecked}
    //     onItemClick={this.onItemClick.bind(this, rowData)}
    //   />
    // }
    return <Container>
      <Header loading={loading}>履约提货</Header>
      <Wrapper flex>
        {/*<ListView*/}
        {/*  dataSource={dataSource}*/}
        {/*  renderBodyComponent={() => <div/>}*/}
        {/*  renderRow={renderRow}*/}
        {/*  pageSize={7}*/}
        {/*  style={{ flex: '1 1 auto', overflow: 'auto' }}*/}
        {/*/>*/}
        {
          data.map(item => {
            let { id, productId, productName, productCount, currentPrice, state, productPic } = item
            return <AgreementDeliveryItem
              key={id}
              id={id}
              index={productId}
              title={productName}
              productId={productId}
              price={currentPrice}
              checked={state === 1}
              amount={productCount}
              imgSrc={productPic}
              onItemChecked={this.onItemChecked}
              onItemClick={this.onItemClick.bind(this, item)}
            />
          })
        }
      </Wrapper>
      <Footer className={'justify-end'}>
        <ConfirmButton type={'danger'} onClick={this.cartConfirm}>去结算</ConfirmButton>
      </Footer>
    </Container>
  }

  // event
  // 转跳到详情页
  onItemClick = item => {
    // 20241204 这里跳去的details不能有加入购物车，仅仅展示details
    this.props.history.push(`${window.PATH.MALL_PRODUCT_DETAILS}/${item['id']}?onlyDisplay=1`)
  }
  // 选中购物车商品
  onItemChecked = (itemData) => {
    // console.log(itemData, this.state.data)
    let data = this.state.data.map(item => {
      console.log(itemData, item)
      // if (item['id'] === itemData['id']) {
      //   item['state'] = itemData['checked'] ? 1 : 0
      // }
      item['state'] = item['id'] === itemData['id'] ? 1 : 0
      return item
    })
    this.setState({ data })
    // this.delayDispatch(putCartItem(itemData))
  }

  cartConfirm = () => {
    // let { data, amount, total } = this.props.store
    let checkedData = this.state.data.filter(item => item['state'] === 1)
    if (checkedData.length > 0) {
      this.props.dispatch(setOrderConfirmData({ productList: checkedData }))
      this.props.history.push(window.PATH.AGREEMENT.DELIVERY_CONFIRM)
    } else {
      window.toast.info('你还没选择商品哦')
    }

    // if (amount > 0) {
    //   let checkedData = data.filter(item => item.checked === '1')
    //   total = total.toFixed(2)
    //   this.props.dispatch(setOrderConfirm({ amount, total, data: checkedData }))
    //   this.props.history.push(window.PATH.MALL_ORDER_CONFIRM)
    // } else {
    //   window.toast.info('你还没选择商品哦')
    // }
  }
}

export { AgreementDelivery }
